<div class="p-8">
  <h1 class="text-2xl font-semibold mb-4">Domain event log</h1>
  <p-table [value]="events.value() ?? []">
    <ng-template pTemplate="header">
      <tr>
        <th>ID</th>
        <th>Type</th>
        <th>User</th>
        <th>Timestamp</th>
        <th>Payload</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-event>
      <tr>
        <td>{{ event.id }}</td>
        <td>{{ event.eventType }}</td>
        <td>{{ event.userId ?? '-' }}</td>
        <td>{{ event.timestamp | date: 'dd-MM-yyyy HH:mm:ss' }}</td>
        <td><pre class="text-xs whitespace-pre-wrap">{{ event.payload | json }}</pre></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="text-center">No domain events found</td>
      </tr>
    </ng-template>
  </p-table>
</div>
